/**
 * Asynchronously loads the component for GuaranteeSummaryDetailPage
 */

import { lazyLoad } from 'utils/loadable';

export const GuaranteeSummaryDetailPage = lazyLoad(
  () => import('./index'),
  module => module.GuaranteeSummaryDetailPage,
);
